import React from 'react'
import PropTypes from 'prop-types'

const sleepTimeSVG = ({ color, width, height }) => (
    <svg viewBox="0 0 47.504 48" width={width} height={height}>
        <g>
            <path
                d=" M 11.597 27.928 L 16.272 21.756 C 16.834 21.195 17.208 20.634 17.769 20.073 L 17.769 20.073 L 11.971 20.073 L 11.971 18.577 L 20.013 18.577 L 20.013 19.699 L 15.337 25.87 C 14.776 26.432 14.402 26.993 14.028 27.367 L 14.028 27.554 L 20.013 27.554 L 20.013 29.05 L 11.597 29.05 L 11.597 27.928 L 11.597 27.928 Z  M 17.021 44.012 L 21.322 38.588 C 21.696 38.027 22.07 37.653 22.444 37.092 L 22.444 37.092 L 17.395 37.092 L 17.395 35.783 L 24.501 35.783 L 24.501 36.718 L 20.387 42.141 C 20.013 42.703 19.639 43.077 19.265 43.638 L 19.265 43.638 L 24.501 43.638 L 24.501 44.947 L 17.021 44.947 L 17.021 44.012 L 17.021 44.012 Z  M 25.811 15.584 L 31.982 7.355 C 32.73 6.607 33.292 5.859 33.853 5.111 L 33.853 5.111 L 26.372 5.111 L 26.372 3.054 L 37.032 3.054 L 37.032 4.55 L 30.673 12.779 C 30.112 13.527 29.551 14.275 28.99 15.023 L 28.99 15.023 L 37.032 15.023 L 37.032 17.08 L 25.811 17.08 L 25.811 15.584 Z "
                fillRule="evenodd" fill={color}/>
        </g>
    </svg>
)

sleepTimeSVG.defaultProps = {
    color: '#0070BA',
    width: 24,
    height: 24,
}

sleepTimeSVG.propTypes = {
    color: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
}

export default (sleepTimeSVG)
